import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import { SubmitHandler, useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import ThankYou from "@pages/contact/parts/thank-you";

const brands = [
  { src: "/assets/images/kwikcheckoutcod/lakme.png", alt: "Lakme" },
  { src: "/assets/images/kwikcheckoutcod/boat.png", alt: "Boat" },
  { src: "/assets/images/kwikcheckoutcod/limeroad.png", alt: "Limeroad" },
  { src: "/assets/images/kwikcheckoutcod/neemans.png", alt: "Neemans" },
  { src: "/assets/images/kwikcheckoutcod/firebolt.png", alt: "Firebolt" },
  { src: "/assets/images/kwikcheckoutcod/lenskart.png", alt: "Lenskart" },
  { src: "/assets/images/kwikcheckoutcod/itc.png", alt: "ITC" },
  { src: "/assets/images/kwikcheckoutcod/mamaearth.png", alt: "MamaEarth" },
];

const platformOptions = [
  {
    name: "Shopify",
    subName: [],
  },
  {
    name: "Woocommerce",
    subName: [],
  },
  {
    name: "Other",
    subName: ["Magento", "SalesForce", "PHP", "React"],
  },
];

export const SectionOne = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const recaptchaRef = React.useRef<ReCAPTCHA>();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    brand_url: "",
    platform: "",
    sub_platform: "",
    g_recaptcha_token: ""
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { handleSubmit, getValues } = useForm({});

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Allow only + and digits in mobile
    if (name === "mobile" && /[^\d+]/.test(value)) return;

    if (name === "platform") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        sub_platform: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim())
      newErrors.name = "Full name is required.";
    if (!formData.mobile.trim())
      newErrors.mobile = "Mobile number is required.";
    else if (!/^\+?\d{7,15}$/.test(formData.mobile.trim()))
      newErrors.mobile = "Enter a valid mobile number.";

    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email.";

    if (!formData.brand_url.trim()) {
      newErrors.brand_url = "Brand URL is required.";
    }


    if (!formData.platform) newErrors.platform = "Platform is required.";

    const selectedPlatform = platformOptions.find(
      (opt) => opt.name === formData.platform
    );
    if (selectedPlatform?.subName && selectedPlatform?.subName.length > 0 && !formData.sub_platform)
      newErrors.sub_platform = "Sub-platform is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setSuccessMessage("");

  //   if (!validateForm()) return;

  //   const payload = {
  //     email: formData.email,
  //     mobile: formData.mobile,
  //     name: formData.name,
  //     brand_url: formData.brand_url,
  //     platform: formData.platform,
  //     sub_platform: formData.sub_platform,
  //   };

  //   if (recaptchaRef.current) {
  //     const recaptcha = recaptchaRef.current as any;
  //     const token = await recaptcha.executeAsync();
  //     recaptcha.reset();
  //     try {
  //       setLoading(true);
  //       await axios.post(API_BASE_URL + "form/kwik-checkout-cod",
  //         { ...payload, "g-recaptcha-response": token }
  //       );
  //       setSuccessMessage("Demo booked successfully!");
  //       setFormData({
  //         name: "",
  //         mobile: "",
  //         email: "",
  //         brand_url: "",
  //         platform: "",
  //         sub_platform: "",
  //       });
  //     } catch (error) {
  //       console.error("Form submission error:", error);
  //       setSuccessMessage("Something went wrong. Please try again.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    // formData.platform = getValues("platform");
    // formData.sub_platform = getValues("sub_platform");
    axios
      .post(API_BASE_URL + "form/kwik-checkout-cod", formData)
      .then(function (response) {
        setSuccessMessage("Demo booked successfully!");
        setFormData({
          name: formData.name,
          mobile: "",
          email: "",
          brand_url: "",
          platform: "",
          sub_platform: "",
          g_recaptcha_token: ""
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    if (!data.product) {
      data.product = [];
    }
    setSuccessMessage("");
    if (!validateForm()) return;

    // data.source = params.get("utm_source");
    // data.medium = params.get("utm_medium");
    // data.campaign = params.get("utm_campaign");
    handleRecaptchaSubmit();
  };

  const selectedPlatform = platformOptions.find(
    (opt) => opt.name === formData.platform
  );

  return (
    <div className="kwik-checkout section-1">
      <div className="container-fluid">
        <div className="row banner align-items-center">
          <div className="col-lg-6 col-md-12 banner-left">
            <div className="heading">
              <p style={{ fontWeight: "500", fontSize: "20px" }}>
                KwikCheckout for eCommerce & D2C
              </p>
              <h1 style={{ fontWeight: "800" }}>
                India's #1 one-click <br />checkout solution with COD <br /> RTO intelligence
              </h1>
              {[
                "Up to 50% conversion uplift in prepaid orders",
                "Up to 3X GMV boost",
                "250+ discounting configurations",
                "Secure payments with auto PA-PG routing",
                "Effectively reduce RTO by up to 40%",
              ].map((text, idx) => (
                <p key={idx} className="mt-3 second">
                  <img
                    src="/assets/images/kwikcheckoutcod/checkmark.png"
                    alt=""
                  />
                  <span className="mx-2">{text}</span>
                </p>
              ))}
            </div>
          </div>

          <div className="col-lg-6 col-md-12 banner-right mt-4 mt-lg-0">
            <div style={{ marginLeft: "50px" }}>
              <div className="form-wrapper">
                <div className="form-container">
                  {successMessage && (
                    <Fade direction="right">
                      <ThankYou name={formData?.name} />
                    </Fade>
                  )}
                  {
                    !successMessage &&
                    <form
                      className="demo-form"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                    >
                      <h2>Book a Demo</h2>

                      <label htmlFor="name">Full name*</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.name}
                        </p>
                      )}

                      <label htmlFor="mobile">Mobile Number*</label>
                      <input
                        type="tel"
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                      {errors.mobile && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.mobile}
                        </p>
                      )}

                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.email}
                        </p>
                      )}

                      <label htmlFor="brand_url">Brand URL*</label>
                      <input
                        type="url"
                        id="brand_url"
                        name="brand_url"
                        value={formData.brand_url}
                        onChange={handleChange}
                      />
                      {errors.brand_url && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.brand_url}
                        </p>
                      )}

                      <label htmlFor="platform">Platform*</label>
                      <select
                        id="platform"
                        name="platform"
                        value={formData.platform}
                        onChange={handleChange}
                      >
                        <option value="">Select platform</option>
                        {platformOptions.map((opt) => (
                          <option key={opt.name} value={opt.name}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                      {errors.platform && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.platform}
                        </p>
                      )}

                      {selectedPlatform?.subName.length > 0 && (
                        <>
                          <label htmlFor="sub_platform">Sub Platform*</label>
                          <select
                            id="sub_platform"
                            name="sub_platform"
                            value={formData.sub_platform}
                            onChange={handleChange}
                          >
                            <option value="">Select sub-platform</option>
                            {selectedPlatform.subName.map((sub) => (
                              <option key={sub} value={sub}>
                                {sub}
                              </option>
                            ))}
                          </select>
                          {errors.sub_platform && (
                            <p className="error" style={{ color: "red" }}>
                              {errors.sub_platform}
                            </p>
                          )}
                        </>
                      )}

                      <ReCAPTCHA
                        ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
                        sitekey={RECAPTCHA_SITE_KEY}
                        size="invisible"
                        onChange={handleRecaptchaChange}
                      />

                      <button type="submit" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                      {successMessage && (
                        <p className="success">{successMessage}</p>
                      )}
                    </form>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="banner-slider">
          <p className="slider-text">Trusted by 10,000+ Brands</p>
          <div className="slider-container">
            <div className="slider-track">
              {[...brands, ...brands].map((brand, index) => (
                <img
                  key={index}
                  src={brand.src}
                  alt={brand.alt}
                  className="slider-img"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
